export default __webpack_public_path__ + "static/media/cross_icon_grey.f7777c3a.svg";